import HealthClaim from './HealthClaim'

export default HealthClaim
